<template>
    <tr class="center aligned">
        <td> {{ human_datetime(operation.created_at) }}</td>
        <td> {{ operation.number || '-' }} </td>
        <td> {{ customer_name || '-' }} </td>
        <td> {{ operation.customer_note || '-' }} </td>
        <td> {{ operation.provider_note || '-' }} </td>
        <td :class="{negative: operation.core_waybills.length == 0}">
            {{ done_core_waybills.length }} / {{ operation.core_waybills.length }}
        </td>
        <td>
            <a :href="operation.original_file_url">{{ operation.original_file_name }}</a>
        </td>
        <td class="center aligned">
            <router-link
                :to="{name: 'edit_provider_operation', params: {identity: operation.identity}}"
                class="ui basic primary button"
            >
                {{ $t('ui.general.detail') }}
            </router-link>
        </td>
    </tr>
</template>

<script>
import moment from 'moment'
export default {
    props: {
        operation: Object
    },
    data() {
        return {
            is_processing: false,
        }
    },
    computed: {
        customer_name() {
            if (this.operation.customer) {
                return this.operation.customer.company_name
            } else {
                return null
            }
        },
        done_core_waybills() {
            return _.filter(this.operation.core_waybills, core_waybill => {
                return core_waybill.is_done == true
            })
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        cancel() {
            if (confirm(this.$t('ui.notifications.warning.are_you_sure_to_cancel_it'))) {
                this.is_processing = true
                var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_operation_cancel).parse(
                    {
                        "operation_identity": this.operation.identity,
                    }
                )
                axios.post(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        var myIndex = this.$store.state.provider.operations_module.operations.indexOf(
                            this.operation
                        )
                        this.$store.state.provider.operations_module.operations.splice(
                            myIndex, 1
                        )
                        this.$noty.success("訂單取消成功")
                    } else {
                        this.$noty.error("訂單取消失敗")
                    }
                })
                .catch(error => {
                    console.log(error)
                    if (!error.response) {
                        // Network Error
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality')+": "+
                            this.$t('ui.general.server_offline')
                        )
                    } else {
                        this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                    }
                })
                this.is_processing = false
            }
        },
    },
    components: {
    }
}
</script>
